import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
import {async} from 'regenerator-runtime';
import insightIcon from '../PortalsBlock/images/icon-insight/icon-120-insight.svg';
import dwhSelfCareSuspendActivateAccount from './dwhReports';
import Popup from 'app/Components/Shared/PopUpWithAnimation/PopUpWithAnimation';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';

const CancellationReasonPopup = (props) => {
  const [selectedReason, setSelectedReason] = useState(null);

  const handleClick = async (action,reason) => {
    await props.onClickActionButton(action,reason);
  };

  return (
    <Container fluid>
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center'>
          <Image src={insightIcon} alt='התראה' />
        </Row>
        <Row className='justify-content-center'>
          <span className='title'>לפני שנמשיך</span>
        </Row>
        <Row className='justify-content-center mt-2'>
          <span className='content'>בחר סיבת חסימת מנוי</span>
        </Row>
      </div>
      <Row className='justify-content-center'>
      <div>
        <ReactSelect
          className='cancellation-box'
          getOptionLabel={(option) => option?.description}
          getOptionValue={(option) => option?.codeName}
          placeholder='סיבת חסימה'
          value={props.suspensionReasons.find((option) => option?.codeName === selectedReason)}
          name='selected'
          options={props.suspensionReasons}
          onChange={(option) => setSelectedReason(option?.codeName)}
        />
      </div>
    </Row>
      <Row className='justify-content-center mt-2'>
        <button
          className='btn-submit-purple'
          onClick={() => {
            handleClick('suspend', selectedReason);
          }}
          disabled={!selectedReason}>
          המשך לחסימת מנוי
        </button>
      </Row>
      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {
    suspensionReasons: state.portalsBlock.suspensionReasons,
  };
}
export default connect(mapStateToProps,{})(CancellationReasonPopup);
